import { useTheme } from '@shared/providers/theme/ThemeContext';
import { SERVICE_TYPE_A2, SERVICE_TYPE_R2 } from '@/constants/serviceType';

/**
 * X-Service-Type for clinic portal APIs (aligned with useMainClinicLocation).
 * Pure localStorage — same source as sidebar / clinic master calls.
 */
export function getClinicPortalServiceTypeHeader(): string {
  return localStorage.getItem('service_type') || SERVICE_TYPE_R2;
}

/**
 * Reactive clinic-portal service type (A2/R2).
 *
 * Reads from ThemeContext so that switching service via the sidebar selector
 * re-renders the consumer (and changes its React Query key) — unlike the plain
 * localStorage getter above, which is not reactive. Use this in list hooks that
 * must reload when the user toggles A↔R (HIT-4650). Falls back to the stored
 * value when the theme is in admin mode.
 */
export function useClinicPortalServiceType(): string {
  const { serviceType } = useTheme();
  return serviceType === SERVICE_TYPE_A2 || serviceType === SERVICE_TYPE_R2
    ? serviceType
    : getClinicPortalServiceTypeHeader();
}
